import { createContext, useContext } from 'react'

export const DashboardContext = createContext<any>({})

export const useDashboardContext = () => {
  const context = useContext(DashboardContext)
  return context
}
